import script from "./page-1-b3.vue?vue&type=script&setup=true&lang=js"
export * from "./page-1-b3.vue?vue&type=script&setup=true&lang=js"

import "./page-1-b3.vue?vue&type=style&index=0&id=454e5124&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454e5124"]])

export default __exports__